/**
 * Production build config — flat/legacy-stack keys copied verbatim from
 * apps/curbnturf/src/environments/environment.prod.ts (same production
 * backend + production Cognito pool as curbnturf). `baseUrl`/`cognitoCallback*`
 * and the nested `cognito` block point back at cnt-landing's own production
 * origin, not curbnturf.com — update the origin below once cnt-landing has
 * a real production deployment URL.
 */
export const environment = {
  production: true,
  staging: false,
  program: 'web',
  baseUrl: 'https://www.curbnturf.com',
  apiUrl: 'https://api.curbnturf.com',
  poiApiUrl: 'https://poi.curbnturf.com',
  boondockSearchApiUrl: 'https://boondock.curbnturf.com/v2',
  searchApiUrl: 'https://search.curbnturf.com/v2',
  imageUrl: 'https://images.curbnturf.com',
  mapOldAppCode: 'LKVngL6HJzQjfGIcsfjo9w',
  mapOldAppId: '78EtQKL0GXmuIHrx6FQj',
  mapApiKey: 'xOBTyVJNHU0jZNzLJEKd5rCuiP1jwF4ojxbAUnAOXcI',
  mapboxToken: 'pk.eyJ1IjoiamVkc21pdGhjbnQiLCJhIjoiY21rYmVib3dhMDMwYjNmcTUwM3lrcDVzYiJ9.wx9l3NHiUrO1Lp6131-eKw',
  vapidPublic: 'BJ10wNQS3giBrRXBt-E2dECZ6boVgaU8z0tymA4yVvjKjnAx9Tq2wEudYQS8lo1kxfjheCCnE6icuoNOE4ZXYcg',
  gaCode: 'UA-126794497-2',
  ga4Code: 'G-CNN5K3XF5R',
  googleAdsId: 'AW-722535941',
  hotjarId: 3149312,
  hotjarVersion: 6,
  metaPixelId: '7160454707365536',

  // AWS Cognito (flat, legacy-stack shape — matches curbnturf's production pool)
  awsRegion: 'us-west-2',
  cognitoUserPoolId: 'us-west-2_0lbl9hIVz',
  cognitoClientId: '15pfkn9ondnh9fjvi0bjaqf2ps',
  cognitoDomain: 'auth.curbnturf.com',
  cognitoCallback: 'https://www.curbnturf.com/auth/redirect',
  // Hosts that sign in/out on their own origin instead of www (see
  // data-access-cnt's web-callback.ts); each is on the Cognito app client.
  cognitoWebOrigins: ['https://www.curbnturf.com', 'https://v2.curbnturf.com', 'https://new.curbnturf.com'],

  // Unused in the web app
  cognitoCallbackIOS: 'curbnturf://auth/redirect',
  cognitoLogoutCallbackIOS: 'curbnturf://home/',
  cognitoCallbackApp: 'https://www.curbnturf.com/auth/redirect',

  // Converge CC Processing
  convergeGetTokenUrl: 'https://www.convergepay.com/hosted-payments/service/payment/hpe/process',

  // Ionic Native Only
  offlineDatabaseName: 'curbnturf-offline-data',

  // AWS Cognito (nested, Amplify shape — used by app.config.ts until Phase 1)
  cognito: {
    userPoolId: 'us-west-2_0lbl9hIVz',
    userPoolClientId: '15pfkn9ondnh9fjvi0bjaqf2ps',
    region: 'us-west-2',
    hostedUiDomain: 'auth.curbnturf.com',
    redirectSignIn: ['https://www.curbnturf.com/auth/redirect'],
    redirectSignOut: ['https://www.curbnturf.com/'],
    scopes: ['email', 'openid', 'profile'],
  },
};
